import { useQuery } from "@tanstack/react-query";
import { requestJson } from "@/lib/api-client";
import type { StorefrontsResponse } from "@/types/storefront";
import { queryKeys } from "@/lib/query-keys";

export function useStorefronts() {
  return useQuery({
    queryKey: queryKeys.storefronts.all(),
    queryFn: async () => {
      return await requestJson<StorefrontsResponse>("/api/storefronts");
    },
  });
}
